import { render, staticRenderFns } from "./ReportePlaneacionSaldosPartidasView.vue?vue&type=template&id=6e1a8352&"
import script from "./ReportePlaneacionSaldosPartidasView.vue?vue&type=script&lang=js&"
export * from "./ReportePlaneacionSaldosPartidasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports